type HeadingProps = {
    level?: 1 | 2 | 3 | 4 | 5 | 6;
    children: string | React.ReactNode;
    className?: string;
};

export default function Heading({
    level = 1,
    children,
    className = '',
}: HeadingProps) {
    const Component: any = `h${level}`;

    return (
        <div className='prose'>
            <Component className={className}>{children}</Component>
        </div>
    );
}
